/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForCredentialsValidation extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForCredentialsValidation.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForCredentialsValidation>): ProgressDetailsForCredentialsValidation {
        let obj = Object.assign(new ProgressDetailsForCredentialsValidation(), model);
        ProgressDetailsForCredentialsValidation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForCredentialsValidation>): ProgressDetailsForCredentialsValidation {
        if (!model) return null;
        return ProgressDetailsForCredentialsValidation.newInstance(<ProgressDetailsForCredentialsValidation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForCredentialsValidation) {
        if (!obj) return;

        models.ProgressDetailsForCredentialsValidation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForCredentialsValidation): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForCredentialsValidation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.start_time === "string") {
            this.start_time = new Date(<string><any>this.start_time);
        }
        if (typeof this.expire_time === "string") {
            this.expire_time = new Date(<string><any>this.expire_time);
        }
    }

    /**
     * Key Id
     */
    key_id: string;

    /**
     * Display Name
     */
    displayName: string;

    /**
     * Start Time
     */
    start_time: Date;

    /**
     * Expire Time
     */
    expire_time: Date;

}
